import IOption from "common/models/IOption";
import { IWidgetProps } from "decorator-form";
import React from "react";
import ButtonSelect from "./common/ButtonSelect";

/**
 * @description input for selecting css text transform options
 * @author chills
 */

export enum TextTransform {
	NONE = "none",
	UPPERCASE = "uppercase",
	LOWERCASE = "lowercase",
	CAPITALIZE = "capitalize"
}

const options: IOption[] = [
	{label: "None", value: TextTransform.NONE},
	{label: "Uppercase", value: TextTransform.UPPERCASE},
	{label: "Lowercase", value: TextTransform.LOWERCASE},
	{label: "Capitalize", value: TextTransform.CAPITALIZE}
];

const TextTransformWidget: React.SFC<IWidgetProps<string>> = (props) => <ButtonSelect {...props} options={options} />;

export default TextTransformWidget;



// WEBPACK FOOTER //
// ./src/common/form/widgets/TextTransformWidget.tsx